import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { useT } from "../context/LangContext";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { TransparencySection } from "../components/TransparencySection";
import { LoginForm } from "../components/LoginForm";

export default function Accedi() {
  const { user, loading } = useAuth();
  const { t } = useT();
  const c = t.login;
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/area-soci", { replace: true });
  }, [user, loading, navigate]);

  return (
    <>
      <PageHero kicker={c.heroKicker} titleLines={c.heroTitleLines} intro={c.heroIntro} />
      <section className="mx-auto max-w-7xl px-5 md:px-8 pt-12 md:pt-16 grid gap-8 md:grid-cols-12" data-testid="login-section">
        <Reveal className="md:col-span-6">
          <div className="rounded-[2rem] border border-border bg-surface p-8 md:p-10">
            <h2 className="font-display font-extrabold tracking-tighter text-2xl md:text-3xl text-ink mb-3">{c.cardTitle}</h2>
            <p className="text-stone mb-8">{c.cardBody}</p>
            <LoginForm c={c} />
          </div>
        </Reveal>
        <div className="md:col-span-6 space-y-6">
          <Reveal>
            <div className="rounded-2xl border border-border bg-sand p-7">
              <ShieldCheck size={34} weight="duotone" className="text-terracotta mb-4" />
              <h3 className="font-display font-bold tracking-tight text-lg text-ink mb-2">{c.protectedTitle}</h3>
              <p className="text-sm text-stone leading-relaxed">{c.protectedBody}</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-2xl bg-forest text-bone p-7">
              <p className="font-serif italic text-2xl leading-snug">{c.quote}</p>
            </div>
          </Reveal>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-5 md:px-8 pb-14 md:pb-20">
        <TransparencySection />
      </section>
    </>
  );
}
